import { render, staticRenderFns } from "./StaffShift.vue?vue&type=template&id=1db95967"
import script from "./StaffShift.vue?vue&type=script&lang=js"
export * from "./StaffShift.vue?vue&type=script&lang=js"
import style0 from "./StaffShift.vue?vue&type=style&index=0&id=1db95967&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports